import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GoogleMap, MapMarker, GoogleMapsModule } from "@angular/google-maps";
import { NgFor, NgIf } from "@angular/common";
import { GoogleMapsLoaderService } from "../../../../shared/services/google-map-loader.service";
import { environment } from "../../../../../environments/environment";
import { SimpleChanges } from "@angular/core";

@Component({
  selector: "glo-google-map",
  templateUrl: "./google-map.component.html",
  styleUrls: ["./google-map.component.scss"],
  imports: [GoogleMapsModule, MapMarker, GoogleMap, NgFor, NgIf],
})
export class GoogleMapComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("map", { static: false }) map!: GoogleMap;

  loader = inject(GoogleMapsLoaderService);

  assetUrl = environment.assetBaseUrl;

  @Input() center: google.maps.LatLngLiteral = { lat: 24.8607, lng: 67.0011 };
  @Input() zoom = 15;
  @Input() markers: google.maps.LatLngLiteral[] = [];

  @Input() bounds: google.maps.LatLngBoundsLiteral | null = null;

  mapLoaded = false;
  customIcon: any = {
    url: this.assetUrl + "icons/map-marker.svg",
  };
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
  };

  async ngOnInit() {
    await this.loader.load();
    this.mapLoaded = true;
  }

  ngAfterViewInit(): void {
    this.applyBounds();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["bounds"] || changes["markers"]) {
      this.applyBounds();
    }
  }

  private applyBounds(): void {
    if (!this.map || !this.map.googleMap) return;
    if (!this.bounds) return;
    if (!this.markers || this.markers.length < 2) return;

    this.map.googleMap.fitBounds(this.bounds, 40);
  }
}
